import { getNuclide } from "./services/nuclideService";
import { RED, BLACK, WHITE, BLUE } from "./theme/palette";

const TWO_PI = 2 * Math.PI;

class AtomicModelCanvas {
    constructor({ ctx, canvasWidth, canvasHeight }) {
        this.ctx = ctx;
        this.setSize(canvasWidth, canvasHeight);

        this.initiated = true;
    }

    setSize(canvasWidth, canvasHeight, shouldDraw) {
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;

        this.ctx.canvas.width = this.canvasWidth;
        this.ctx.canvas.height = this.canvasHeight;

        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        this.ctx.canvas.width = this.canvasWidth;
        this.ctx.canvas.height = this.canvasHeight;

        const maxSize = Math.min(canvasWidth, canvasHeight);
        this.gap = Math.floor(maxSize / 20);
        this.radius = this.gap * 0.7;

        if (shouldDraw) this.draw();
    }

    setTarget(nuclide) {
        this.target = getNuclide(nuclide);
        this.draw();
    }

    calRingCapacity(level) {
        return 2 * (level * level);
    }

    //recursive method that make sure draw the circles from outside to inside
    drawNeutronAndProton(centerX, centerY, newCap, level, remainNeutron, remainProton) {
        const remain = remainNeutron + remainProton;
        if (level >= 7 || remain <= 0) return;
        let capacity = newCap * 3;

        if (capacity >= remain) {
            capacity = remain;
        }

        if (capacity >= 20) {
            capacity = 20;
        }

        let drawNeutron = Math.floor(Math.random() * capacity);
        let drawProton = capacity - drawNeutron;

        remainNeutron -= drawNeutron;
        remainProton -= drawProton;

        if (remainNeutron <= 0) {
            drawNeutron += remainNeutron;
            drawProton -= remainNeutron;
            remainProton += remainNeutron;
            remainNeutron = 0;
        }
        if (remainProton <= 0) {
            drawProton += remainProton;
            drawNeutron -= remainProton;
            remainNeutron += remainProton;
            remainProton = 0;
        }

        //recursion
        this.drawNeutronAndProton(centerX, centerY, capacity, level + 1, remainNeutron, remainProton);

        const increaseAngle = 360 / capacity;

        let remainDraw = drawNeutron + drawProton - 1;
        while (remainDraw >= 0) {
            const dist = level * (this.radius * (Math.random() * (0.7 - 0.5) + 0.6));
            const rad = Math.radians(remainDraw * increaseAngle - (Math.random() * (90 - 70) + 45));
            const px = centerX + dist * Math.cos(rad);
            const py = centerY + dist * Math.sin(rad);
            let color = null;

            if (drawNeutron <= 0) {
                color = RED;
                drawProton--;
            } else if (drawProton <= 0) {
                color = BLUE;
                drawNeutron--;
            } else if (Math.random() > 0.5) {
                color = BLUE;
                drawNeutron--;
            } else {
                color = RED;
                drawProton--;
            }

            var grd = this.ctx.createRadialGradient(px, py - this.radius, 0, px, 0, py);
            grd.addColorStop(0, WHITE);
            grd.addColorStop(1, color);
            // Fill with gradient
            this.ctx.fillStyle = grd;
            this.ctx.beginPath();
            this.ctx.arc(px, py, this.radius, 0, TWO_PI);
            this.ctx.fill();
            this.ctx.stroke();
            remainDraw = drawNeutron + drawProton - 1;
        }
    }

    draw() {
        //clear canvas
        this.ctx.fillStyle = WHITE;
        this.ctx.globalAlpha = 1;
        this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);

        if (this.target) {
            this.ctx.lineWidth = 0.5;
            this.ctx.strokeStyle = BLACK;

            const centerX = this.canvasWidth / 2;
            const centerY = this.canvasHeight / 2;
            let capacity;
            let level = 1;

            this.drawNeutronAndProton(centerX, centerY, 1, 1, this.target.neutron, this.target.proton);

            let electronCount = this.target?.proton || 0;
            do {
                this.ctx.fillStyle = BLACK;
                //calculate ring capacity
                capacity = this.calRingCapacity(level);

                //if the electronCount is less than ringCapacity
                //set ringCapacity to electronCount and set electronCount to 0
                //else decrease electronCount by ringCapacity
                if (electronCount <= capacity) {
                    capacity = electronCount;
                    electronCount = 0;
                } else {
                    electronCount -= capacity;
                }
                if (capacity > 0) {
                    const dist = (level + 4) * this.gap;
                    this.ctx.beginPath();
                    this.ctx.arc(centerX, centerY, dist, 0, TWO_PI);
                    this.ctx.stroke();
                    const increaseAngle = 360 / capacity;
                    let ex, ey, rad;
                    //draw all electrons
                    for (let i = 0; i < 360; i += increaseAngle) {
                        rad = Math.radians(i - 90);
                        ex = centerX + dist * Math.cos(rad);
                        ey = centerY + dist * Math.sin(rad);
                        this.ctx.beginPath();
                        this.ctx.arc(ex, ey, 2, 0, TWO_PI);
                        this.ctx.fill();
                    }
                    level++;
                }
            } while (electronCount > 0);
        }
    }
}

export default AtomicModelCanvas;
